"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_dev_1 = require("./is-dev");
var getInstanceFromUrl = function () {
    var url = window.location.href;
    var instance = /instance=([a-zA-Z0-9-\._]*)/.exec(url);
    return instance && instance[1];
};
var getInstancePolyfill = function () { return 'fakeInstance'; };
var WixPolyfill = {
    addEventListener: function (eventName, callback) {
        var params;
        switch (eventName) {
            case WixPolyfill.Events.STYLE_PARAMS_CHANGE:
                params = { numbers: {}, booleans: {}, colors: {} };
                break;
            default:
                params = {};
                break;
        }
        WixPolyfill.Events.STATE_CHANGED !== eventName && setTimeout(function () { return callback(params); });
    },
    removeEventListener: function (eventName, callback) { },
    getBoundingRectAndOffsets: function (callback) { return callback({ rect: {} }); },
    getCurrentPageId: function () { return new Promise(function (resolve, reject) { return resolve(); }); },
    getSiteMap: function (callback) { return callback([{ isHomePage: true, pageId: '#id' }]); },
    getStateUrl: function (sectionId, state, callback) { },
    replaceSectionState: function (state) { return state; },
    setHeight: function (height) { return height; },
    setPageMetadata: function (data) { return data; },
    scrollTo: function (pos) { return pos; },
    Data: {
        Public: {
            get: function (key, options, onSuccess, onFailure) { },
            set: function (key, value, options, onSuccess, onFailure) { },
            remove: function (key, options, onSuccess, onFailure) { }
        }
    },
    Events: {
        PUBLIC_DATA_CHANGED: 'PUBLIC_DATA_CHANGED',
        STYLE_PARAMS_CHANGE: 'STYLE_PARAMS_CHANGE',
        STATE_CHANGED: 'STATE_CHANGED',
        SETTINGS_UPDATED: 'SETTINGS_UPDATED'
    },
    PubSub: {
        publish: function (eventName, data, isPersistent) { },
        subscribe: function (eventName, callback, receivePastEvents) { }
    },
    Utils: {
        getDeviceType: function () {
            var mobileParamPresent = window.location.href.indexOf('deviceType=mobile') !== -1;
            return mobileParamPresent ? 'mobile' : 'desktop';
        },
        getCompId: function () { return null; },
        getOrigCompId: function () { return null; },
        getViewMode: function () { return 'site'; },
        getInstanceValue: function () { return 'value'; },
        getDemoMode: function () { return false; },
        getLocale: function () { return 'en'; },
        getInstanceId: function () { return '123'; },
        getSiteOwnerId: function () { return 'siteOwnerId'; },
        getUid: function () { return 'uid'; },
        getPermissions: function () { return 'OWNER'; },
        Media: {
            getResizedImageUrl: function (url, width, height) { return url; }
        }
    },
    Styles: {
        getColorByreference: function (reference) { return ({ value: '#000000' }); },
        setNumberParam: function (param) { return param; }
    },
    Performance: {
        applicationLoaded: function () { return ({}); }
    }
};
exports.getInstance = is_dev_1.isDevEnv() ? getInstancePolyfill : getInstanceFromUrl;
exports.default = is_dev_1.isDevEnv() ? WixPolyfill : window['Wix'] || WixPolyfill;
